import React, { useEffect, useMemo, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons"; // Added faDownload
import { Col, Row, Button } from "@themesberg/react-bootstrap";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer"; // Added PDFDownloadLink
import InvoicePdf from "../components/InvoicePdf";
import { useQuery } from "../utils";
import { _fetchApi, _postApi, apiURL } from "../redux/action/api";
import PaymentButton from "./payments/PaymentButton";
import { useHistory, useLocation } from "react-router-dom";
import LandTermalInvoice from "../components/LandTermalInvoice";
import { LandAccountantInvoice } from "./LandAccountantInvoice";
import { useSelector } from "react-redux";
import { CertificateOfCompletion } from "../components/CertificateOfCompletion";
import useIsPhoneSize from "../utils/useIsPhoneSize";
import TermalInvoice from "../components/TermalInvoice";

export default function PaymentInvoice ({ refNo = null }){
  const q = useQuery();
  const ref_no = refNo ? refNo : q.get("ref_no");
  const [qrcode, setQrCode] = useState(null);
  const userInfo = useSelector((state) => state.auth.user);
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const [payModal, setPayModal] = useState(false);
  const [user, setUser] = useState({});
  const [user_id, setUserID] = useState(null);
  const [list, setList] = useState([]);
  const location = useLocation();
  // const isAdmin = location.pathname.includes("/dashboard/");
  const [loading, setLoading] = useState(false);
  const agent = useSelector((state) => state.auth.user);
  const { tax_account = [] } = useSelector((state) => state.auth);
  const isMobile = useIsPhoneSize();

  useEffect(() => {
    if (ref_no) {
      setLoading(true);
      _fetchApi(
        `/transactions/retrieve?query_type=view_invoice&reference_number=${ref_no}&user_id=${userInfo.id}`,
        (resp) => {
          if (resp.success) {
            setList(resp.data);
            if (resp.data[0]?.user_id) {
              setLoading(false);
              setUserID(resp.data[0].user_id);
            }
          }
        },
        (err) => {
          console.error(err);
          setLoading(false);
        },
        (err) => {
          console.log(err);
          setList([]);
          setLoading(false);
        }
      );
    }
    if (user_id) {
      _fetchApi(
        `/users/get-tax-payer?user_id=${user_id}`,
        (resp) => {
          if (resp.success) {
            setUser(resp.data);
          }
        },
        (err) => {
          console.error(err);
          setUser({});
        }
      );
    }
    if (ref_no) {
      const qrCodeUrl = `${apiURL}/transactions/get-qr-code?ref_no=${ref_no}`;
      fetch(qrCodeUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: localStorage.getItem("@@auth_token"),
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.blob();
        })
        .then((blob) => {
          const qrCodeImageUrl = URL.createObjectURL(blob);
          setQrCode(qrCodeImageUrl);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  }, [ref_no, user_id]);

  // const [refNo, setRefNo] = useState(null);
  const total = useMemo(() => {
    return list
      .reduce((it, id) => it + parseFloat(id.cr), 0);
  }, [list]);

  const handleSubmit = () => {
    
  };
  const history = useHistory()

  return (
    <div className="p-0 m-0 h-100 text-center">
      <Col md={2}>
        <Button onClick={() => history.goBack()}>Back</Button>
      </Col>
      {/* {JSON.stringify(list)} */}
      {/* <PDFViewer height="100%" width="70%">
        <InvoicePdf
          user={user}
          data={list
            .filter((item) => item.cr > 0)
            .map((l) => ({ ...l, tax_fee: l.cr }))}
          qrcode={qrcode}
        />
      </PDFViewer> */}
      {loading ? (
        <SkeletonTheme baseColor="#f1f1f1" highlightColor={"#ffffff"}>
          <p>
            <Skeleton count={15} height={50} />
          </p>
        </SkeletonTheme>
      ) : (
        <>
          <Row className="mb-4">
            <Col md={6} >
            {/* {JSON.stringify(list)} */}
              <PaymentButton
                onMouseOver={() => { }}
                addStyle={{ with: "100%", marginTop: 10 }}
                amount={total}
                reference_no={ref_no}
                email={list[0]?.email || 'info@kirs.gov.ng'}
                name={list[0]?.tax_payer}
                taxID={list[0]?.user_id }
                phone={list[0]?.phone}
                data={list}
                sector={list[0]?.sector}
                callback={handleSubmit}
                setPayModal={setPayModal}
                toggle={toggle}
              />
            </Col>
            <Col md={6}>
              {list[0]?.sector !== "LAND" ? null : (
                <>
                  {/* {JSON.stringify(list)} */}
                  <PDFDownloadLink
                    document={
                      <LandTermalInvoice
                        user={user}
                        data={list
                          .filter((item) => item.cr > 0)
                          .map((l) => ({ ...l, tax_fee: l.cr }))}
                        qrcode={qrcode}
                      />
                    }
                    fileName="invoice.pdf"
                  >
                    {({ blob, url, loading, error }) =>
                      loading ? (
                        "Loading document..."
                      ) : (
                        <Button variant="primary">
                          <FontAwesomeIcon icon={faDownload} className="me-2" />
                          Download Invoice PDF
                        </Button>
                      )
                    }
                  </PDFDownloadLink>
                  {list.some(x=>x.department?.includes("SLTR")) ? (
                    <PDFDownloadLink
                      document={
                        <CertificateOfCompletion
                          user={agent}
                          tax_account={tax_account}
                          data={list
                            .filter((item) => item.cr > 0)
                            .map((l) => ({ ...l, tax_fee: l.cr }))}
                        />
                      }
                      fileName="invoice.pdf"
                    >
                      {({ blob, url, loading, error }) =>
                        loading ? (
                          "Loading document..."
                        ) : (
                          <Button variant="primary">
                            <FontAwesomeIcon
                              icon={faDownload}
                              className="me-2"
                            />
                            Certificate of Completion PDF
                          </Button>
                        )
                      }
                    </PDFDownloadLink>
                  ) : list.some(x=>x.department?.includes("Land"))||list.some(x=>x.department?.includes("DEEDS")) ? (
                    <PDFDownloadLink
                      document={
                        <LandAccountantInvoice
                          data={list
                            .filter((item) => item.cr > 0)
                            .map((l) => ({ ...l, tax_fee: l.cr }))}
                        />
                      }
                      fileName="invoice.pdf"
                    >
                      {({ blob, url, loading, error }) =>
                        loading ? (
                          "Loading document..."
                        ) : (
                          <Button variant="primary">
                            <FontAwesomeIcon
                              icon={faDownload}
                              className="me-2"
                            />
                            Download Payment Schedule PDF
                          </Button>
                        )
                      }
                    </PDFDownloadLink>
                  ) : null}
                </>
              )}
            </Col>
          </Row>
          {isMobile ? null : <>
            {list[0]?.sector !== "LAND" ? (
              <Row style={{ height: '70vh' }}>
                <Col md={8}>
                  <Row>
                    <Col md={12}>
                      <PDFDownloadLink
                        document={
                          <InvoicePdf
                            user={user}
                            data={list
                              .filter((item) => item.cr > 0)
                              .map((l) => ({ ...l, tax_fee: l.cr }))}
                            qrcode={qrcode}
                          />
                        }
                        fileName="invoice.pdf"
                      >
                        {({ blob, url, loading, error }) =>
                          loading ? (
                            "Loading document..."
                          ) : (
                            <Button variant="primary">
                              <FontAwesomeIcon icon={faDownload} className="me-2" />
                              Download PDF
                            </Button>
                          )
                        }
                      </PDFDownloadLink>
                    </Col>
                  </Row>
                  <Row>
                    <Col style={{ height: '70vh' }}>
                      <PDFViewer height="100%" width="70%">
                        <InvoicePdf
                          user={user}
                          data={list
                            .filter((item) => item.cr > 0)
                            .map((l) => ({ ...l, tax_fee: l.cr }))}
                          qrcode={qrcode}
                        />
                      </PDFViewer>
                    </Col>
                  </Row>
                </Col>
                <Col md={4}>
                  <PDFDownloadLink
                    document={
                      <TermalInvoice
                        user={user}
                        agent={userInfo}
                        data={list
                          .filter((item) => item.cr > 0)
                          .map((l) => ({ ...l, tax_fee: l.cr }))}
                        qrcode={qrcode}
                      />
                    }
                    fileName="termal-invoice.pdf"
                  >
                    {({ blob, url, loading, error }) =>
                      loading ? (
                        "Loading document..."
                      ) : (
                        <Button variant="primary">
                          <FontAwesomeIcon
                            icon={faDownload}
                            className="me-2"
                          />
                          Termal Invoice
                        </Button>
                      )
                    }
                  </PDFDownloadLink>

                  <PDFViewer height="100%" width="70%">
                    <TermalInvoice
                      user={user}
                      agent={userInfo}
                      data={list
                        .filter((item) => item.cr > 0)
                        .map((l) => ({ ...l, tax_fee: l.cr }))}
                      qrcode={qrcode}
                    />
                  </PDFViewer>
                </Col>
              </Row>
            ) : (
              <>
                {list.some(x=>x.department?.includes("Land"))||list.some(x=>x.department?.includes("DEEDS")) ? (
                  <>
                    {" "}
                    <PDFViewer height="100%" width="50%">
                      <LandTermalInvoice
                        user={user}
                        data={list
                          .filter((item) => item.cr > 0)
                          .map((l) => ({ ...l, tax_fee: l.cr }))}
                        qrcode={qrcode}
                        agent={agent}
                      />
                    </PDFViewer>
                    <PDFViewer height="100%" width="50%">
                      <LandAccountantInvoice
                        data={list
                          .filter((item) => item.cr > 0)
                          .map((l) => ({ ...l, tax_fee: l.cr }))}
                      />
                    </PDFViewer>
                  </>
                ) : list.some(x=>x.department?.includes("SLTR")) ? (
                  <>
                    {" "}
                    <PDFViewer height="100%" width="50%">
                      <LandTermalInvoice
                        user={user}
                        data={list
                          .filter((item) => item.cr > 0)
                          .map((l) => ({ ...l, tax_fee: l.cr }))}
                        qrcode={qrcode}
                        agent={agent}
                      />
                    </PDFViewer>
                    {/* {} */}
                    <PDFViewer height="100%" width="50%">
                      <CertificateOfCompletion
                        user={agent}
                        tax_account={tax_account}
                        data={list
                          .filter((item) => item.cr > 0)
                          .map((l) => ({ ...l, tax_fee: l.cr }))}
                      />
                    </PDFViewer>
                  </>
                ) : (
                  <PDFViewer height="100%" width="100%">
                    <LandTermalInvoice
                      user={user}
                      data={list
                        .filter((item) => item.cr > 0)
                        .map((l) => ({ ...l, tax_fee: l.cr }))}
                      qrcode={qrcode}
                      agent={agent}
                    />
                  </PDFViewer>
                )}
              </>
            )}
          </>}
        </>
      )}
    </div>
  );
};
